import { Datatype } from '../../../../datatype/Datatype.ts';
import { createConditionOperator } from '../../IConditionOperator.ts';

export const ConditionOperatorCountGreater = createConditionOperator({
  code: 'countGreater',
  label: 'conteggio maggiore di',
  description: 'Conteggio maggiore di',
  args: [{ type: 'staticValue', field: { type: Datatype.Number } }],
  allowsField: field => field.type === Datatype.Array,
  compare(value: any, [count]: readonly [number]) {
    if (count == null) return false;
    return Array.isArray(value) && value.length > count;
  },
});
